import { useQuery, UseQueryOptions } from '@tanstack/react-query'

import { QueryKey } from 'consts/query/queryKey'
import { Area, ChanneledRequestParams } from 'types'

import { getAreas } from './requests'

export const useAreasQuery = (
  params: ChanneledRequestParams,
  options: Partial<UseQueryOptions<Area[]>> = {},
) => {
  return useQuery({
    queryKey: [QueryKey.GetAreas, params],
    queryFn: () => getAreas(params),
    ...options,
  })
}
